/**
 * Layout heuristics for the school-order day cards.
 */

/**
 * Threshold above which the collapsed day-card summary stacks each mealtime
 * on its own row (label + that mealtime's grade chips) instead of laying all
 * mealtimes inline. Campuses with many order-group columns wouldn't fit
 * a single inline row, so they break per mealtime.
 */
export const MAX_INLINE_GRADE_COLUMNS = 4

/** True when the collapsed summary should render one mealtime per row. */
export function shouldStackMealtimes(gradeColumnCount: number): boolean {
  return gradeColumnCount > MAX_INLINE_GRADE_COLUMNS
}

/**
 * Compact grade-column label: kept whole through 4 chars (so grade ranges like
 * "9-12" stay full), otherwise the first 4 chars + "." (e.g. "Elementary" →
 * "Elem.").
 */
export function abbreviateGrade(label: string): string {
  return label.length <= 4 ? label : `${label.slice(0, 4)}.`
}

/**
 * Max grade pills (mealtimes × grade columns) a collapsed summary shows before
 * mealtime labels switch from full names to abbreviations. At or below this the
 * row is sparse enough to spell mealtimes out.
 */
export const MAX_FULL_LABEL_PILLS = 6

/**
 * True when the collapsed summary should abbreviate mealtime labels (B/AS/L/…)
 * rather than spell them out — only on dense rows (> MAX_FULL_LABEL_PILLS total
 * grade pills).
 */
export function shouldAbbreviateMealtimes(mealtimeCount: number, gradeColumnCount: number): boolean {
  return mealtimeCount * gradeColumnCount > MAX_FULL_LABEL_PILLS
}
